export enum SendMethodType {
  mobile = "PUSH",
  email = "EMAIL",
}
